import './style.css';
BX.ready(function () {
    // BX.bind(BX('section-sort-count-block'), 'submit', BX.proxy(() => {
    //     let formData = new FormData(this);
    //     if (formData) {
    //         for (const param of this) {
    //             let key = param.name,
    //                 val = param.value
    //             if (key.indexOf('[')) {
    //                 key = key.replace(/\[*/i, '');
    //                 if (settings[key] == undefined) settings[key] = {}
    //                 settings[key][val] = val;
    //             } else {
    //                 settings[key] = val;
    //             }
    //         }
    //         saveCatalogSettings(settings);
    //     }
    // }, this));
})
export function saveCatalogSettings(settings) {
    let event = { settings: settings, return: true };
    BX.onCustomEvent('OnBeforeSaveCatalogSettings', event);
    if (event.return === true && settings) {
        let sCategory = 'germes.multibasket',
            sName = 'CatalogSettings',
            sValName = 'setting',
            sVal = settings,
            bCommon = false;
        BX.userOptions.save(
            sCategory,
            sName,
            sValName,
            sVal,
            bCommon
        ).send(() => {
            BX.onCustomEvent('OnAfterSaveCatalogSettings', event)
        });
    }
}

export function resetCatalogSettings() {
    let event = { settings: settings, return: true };
    BX.onCustomEvent('OnBeforeResetCatalogSettings', event);
    if (event.return === true) {
        let sCategory = 'germes.multibasket',
            sName = 'CatalogSettings',
            bCommon = false,
            callback = () => {
                BX.onCustomEvent('OnAfterResetCatalogSettings', event);
            };
        BX.userOptions.del(
            sCategory,
            sName,
            bCommon,
            callback
        );
    }
}
